import { EMPLOYEE_SNAPSHOTS } from '@src/graphql/queries/employeeSnapshot';
import { usePaginatedFetchItems } from 'pe-core-frontend';
export const useEmployeeSnapshots = ({ clientId, employeeId, startDate, endDate, }) => {
    const { page, setPage, pageSize, setPageSize, total, items, loading, error, orderBy, setOrderBy, orderByDir, setOrderByDir, } = usePaginatedFetchItems({
        spec: {
            clientId,
            employeeId,
            startDate: startDate || undefined,
            endDate: endDate || undefined,
        },
        fetchQuery: EMPLOYEE_SNAPSHOTS,
        dataProp: 'employeeSnapshots',
        initialPageSize: 25,
    });
    return {
        snapshots: items,
        loading,
        page,
        pageSize,
        setPage,
        setPageSize,
        error,
        total,
        orderBy,
        setOrderBy,
        orderByDir,
        setOrderByDir,
    };
};
